import React, { useState } from 'react';

// El mockup de Agencia en un celular, mientras no esté el catálogo con su video (An, 04/11: «agregá un videito en
// agencia cuando esté el catálogo… o hacé un mockup, pero bien UX/UI top»). Tres pantallas, una por cada frase de
// An: incorporar tareas · darles seguimiento · consultar desde el celular. La pantalla la elige la banda (`paso`).
// 🟠 Tareas, cifras y pedidos de muestra, sin nombres de clientes reales.

// Las mismas tareas que el catálogo de la página (catalogo.js), para que el celular y la banda digan lo mismo.
const CATALOGO = [
  { area: 'Administración', nombre: 'Cobranzas', activa: true },
  { area: 'Administración', nombre: 'Resumen de ventas', activa: true },
  { area: 'Atención al cliente', nombre: 'Reseñas', activa: false },
  { area: 'Ventas', nombre: 'Tomar pedidos', activa: false },
  { area: 'Equipo', nombre: 'Avisos al equipo', activa: false },
];

const REGISTRO = [
  { hora: '10:42', pedido: 'Presupuesto: 2 t de hierro del 10', estado: 'Para aprobar' },
  { hora: '09:15', pedido: 'Informe de ventas de octubre', estado: 'Aprobado' },
  { hora: '08:50', pedido: 'Pagos de la semana', estado: 'Aprobado' },
  { hora: 'Ayer', pedido: 'Reseñas nuevas respondidas', estado: 'Aprobado' },
];

const Catalogo = () => {
  const [activas, setActivas] = useState(() => CATALOGO.map(t => t.activa));
  return (
    <>
      <p className="gh-cel__titulo">Tus tareas</p>
      <p className="gh-cel__sub">{activas.filter(Boolean).length} activas · tocá para sumar</p>
      <ul className="gh-cel__lista">
        {CATALOGO.map((t, i) => (
          <li key={t.nombre}>
            <button type="button" className={`gh-cel__tarea${activas[i] ? ' is-activa' : ''}`} aria-pressed={activas[i]}
              onClick={() => setActivas(a => a.map((v, j) => (j === i ? !v : v)))}>
              <span><small>{t.area}</small>{t.nombre}</span>
              <i aria-hidden="true">{activas[i] ? '✓' : '+'}</i>
            </button>
          </li>
        ))}
      </ul>
    </>
  );
};

const Seguimiento = () => (
  <>
    <p className="gh-cel__titulo">Esta semana</p>
    <div className="gh-cel__numeros">
      <span><b>23</b>pedidos hechos</span>
      <span><b>14 h</b>recuperadas</span>
    </div>
    <ul className="gh-cel__registro">
      {REGISTRO.map(r => (
        <li key={r.hora + r.pedido}>
          <small>{r.hora}</small>
          <span>{r.pedido}</span>
          <em className={r.estado === 'Aprobado' ? 'is-ok' : 'is-espera'}>{r.estado}</em>
        </li>
      ))}
    </ul>
  </>
);

// «registro» es un link que lleva a la pantalla del seguimiento (An, 04/11: «registro debería ser un link, como
// para que te des cuenta que podés entrar»).
const Consulta = ({ onIr }) => (
  <>
    <p className="gh-cel__titulo">Tu agencia</p>
    <div className="gh-cel__charla">
      <p className="gh-cel__yo">¿Qué tengo que cobrar esta semana?</p>
      <div className="gh-cel__ella">
        <p>Hoy, <b>$860 mil</b>. La semana que viene, <b>$2,3 M</b>.</p>
        <p className="gh-cel__accion">Recordatorios listos para enviar</p>
      </div>
      <p className="gh-cel__yo">Mandalos.</p>
      <div className="gh-cel__ella"><p>Listo. Quedó en el <button type="button" className="gh-cel__link" onClick={() => onIr?.(1)}>registro</button>.</p></div>
    </div>
    <div className="gh-cel__escribir" aria-hidden="true">Pedile algo a tu agencia…</div>
  </>
);

const PANTALLAS = [Catalogo, Seguimiento, Consulta];

const AgenciaCelular = ({ paso = 0, onIr }) => {
  const Pantalla = PANTALLAS[paso] || Catalogo;
  return (
    <figure className="gh-cel" aria-label="Así se ve Agencia en el celular (ejemplo)">
      <div className="gh-cel__marco">
        <div className="gh-cel__isla" aria-hidden="true" />
        <div className="gh-cel__barra" aria-hidden="true"><span>9:41</span><span>GUIA</span></div>
        <div key={paso} className="gh-cel__pantalla"><Pantalla onIr={onIr} /></div>
      </div>
    </figure>
  );
};

export default AgenciaCelular;
